import api from '../../../lib/api';
import store from '@/store';

export const PUSH_SETTINGS_LOAD = 'PUSH_SETTINGS_LOAD';
export const PUSH_SETTINGS_CREATE = 'PUSH_SETTINGS_CREATE'; // Новый экшен для создания
export const PUSH_SETTINGS_UPDATE = 'PUSH_SETTINGS_UPDATE';

const PUSH_SETTINGS_CHANGE = 'PUSH_SETTINGS_CHANGE';
const PUSH_SETTINGS_LOADING_CHANGE = 'PUSH_SETTINGS_LOADING_CHANGE';
const PUSH_SETTINGS_SAVING_CHANGE = 'PUSH_SETTINGS_SAVING_CHANGE';
const PUSH_SETTINGS_ERRORS_CHANGE = 'PUSH_SETTINGS_ERRORS_CHANGE';

const state = {
    push_settings: null,
    push_settings_loading: false,
    push_settings_saving: false,
    push_settings_errors: {},

    // Шаблон пустых настроек
    push_settings_empty: {
        organization_id: null,
        provider_type: 'pushexpress', // По умолчанию PushExpress
        api_key: '',
        app_id: '',
        base_url: 'https://core.push.express/api/b/v2',
    },
};

/**
 * Получает ID организации авторизованного пользователя
 * @returns {number} ID организации или 0, если не найден
 */
const getCurrentOrganizationId = () => {
    const auth_user = store.state.users.auth_user;
    let organization_id = 0;

    if (auth_user && auth_user?.company?.[0]?.id) {
        organization_id = auth_user.company[0].id;
    }

    return organization_id;
};

const actions = {
    /**
     * Загружает настройки Push текущей организации
     * @param commit
     * @param state
     * @param {Object} [param] - Параметры
     * @param {Object} [param.options] - Дополнительные опции
     */
    [PUSH_SETTINGS_LOAD]({commit, state}, param = {}) {
        let options = param?.options || {};

        // Получаем ID организации из auth_user
        const organization_id = getCurrentOrganizationId();

        commit(PUSH_SETTINGS_LOADING_CHANGE, true);

        return api.load(
            'push_sender.settings.pushexpress',
            organization_id,
            state,
            commit,
            PUSH_SETTINGS_LOADING_CHANGE,
            PUSH_SETTINGS_CHANGE,
            PUSH_SETTINGS_ERRORS_CHANGE,
            options
        );
    },

    /**
     * Создает новые настройки Push для текущей организации
     * @param commit
     * @param state
     * @param {Object} param - Параметры
     * @param {Object} param.model - Данные настроек
     * @param {Object} [param.options] - Дополнительные опции
     */
    [PUSH_SETTINGS_CREATE]({commit, state}, param) {
        let model = param.model;
        let options = param.options || {};

        // Получаем ID организации из auth_user
        model.organization_id = getCurrentOrganizationId();

        return api.create(
            'push_sender.settings.pushexpress',
            '',
            model,
            state,
            commit,
            PUSH_SETTINGS_SAVING_CHANGE,
            PUSH_SETTINGS_CHANGE,
            PUSH_SETTINGS_ERRORS_CHANGE,
            options
        );
    },
    
    /**
     * Обновляет существующие настройки Push для текущей организации
     * @param commit
     * @param state
     * @param {Object} param - Параметры
     * @param {Object} param.model - Данные настроек для обновления
     * @param {Object} [param.options] - Дополнительные опции
     */
    [PUSH_SETTINGS_UPDATE]({commit, state}, param) {
        let model = param.model;
        let options = param.options || {};

        // Получаем ID организации из auth_user
        const organization_id = getCurrentOrganizationId();
        model.organization_id = organization_id;

        // Используем api.update для PATCH запроса
        return api.patch(
            'push_sender.settings.pushexpress',
            organization_id, // ID записи для обновления
            model,
            state,
            commit,
            PUSH_SETTINGS_SAVING_CHANGE,
            PUSH_SETTINGS_CHANGE,
            PUSH_SETTINGS_ERRORS_CHANGE,
            options
        );
    },
};

const mutations = {
    [PUSH_SETTINGS_CHANGE](state, data) {
        state.push_settings = data;
    },

    [PUSH_SETTINGS_LOADING_CHANGE](state, data) {
        state.push_settings_loading = data;
    },

    [PUSH_SETTINGS_SAVING_CHANGE](state, data) {
        state.push_settings_saving = data;
    },

    [PUSH_SETTINGS_ERRORS_CHANGE](state, data) {
        state.push_settings_errors = data || {};
        state.push_settings_loading = false;
    },
};

const getters = {
    isLoading: state => state.push_settings_loading,
    isSaving: state => state.push_settings_saving,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
